import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import constants from 'utils/constants';
import { Link } from 'react-router-dom';

export default function MatchingTutorial({type}) {
    let imgBasePath = constants['imagePath'] + "/tutorial_img/matching/"; 
    const userInfo = useSelector((state) => {
        return state.userInfo;
    });
    return (
        <div>
            <div>
                <img alt={'toturial top moti'} src={`${imgBasePath}matching_tutorial_cover_img-750x937.png`}/>
            </div>

            <TutorialInfoWrapper>
                <StepWrapper style={{background:'#ffffff', paddingBottom: 'calc(100vw*(83/375))'}}>
                    <StepTitleWrapper style={{marginBottom: 'calc(100vw*(44/375))'}}>
                        <StepTitleTxt>목표와 관심사가 같은<br />자기계발 메이트를 찾으시나요?</StepTitleTxt>
                    </StepTitleWrapper>
                    <StepDetailWrapper>
                        <TaskImgWrapper>
                            <img src={`${imgBasePath}matching_tutorial_task_img_1-325x71.png`}/> 
                        </TaskImgWrapper>
                        <TaskImgWrapper>
                            <img src={`${imgBasePath}matching_tutorial_task_img_2-325x71.png`}/> 
                        </TaskImgWrapper>
                        <TaskImgWrapper>
                            <img src={`${imgBasePath}matching_tutorial_task_img_3-325x71.png`}/> 
                        </TaskImgWrapper>
                    </StepDetailWrapper> 
                </StepWrapper>

                <StepWrapper style={{background: '#F7F7F7', paddingBottom: 'calc(100vw*(51/375))'}}>
                    <StepTitleWrapper style={{marginBottom: 'calc(100vw*(14/375))'}}>
                        <StepTitleTxt>달성률 80%이상인<br />찐 자기계발러들만의 커뮤니티</StepTitleTxt>
                    </StepTitleWrapper>
                    <StepDetailWrapper>
                        <StepDetailTxt style={{marginBottom: 'calc(100vw*(40/375))'}}>열정, 의지뿜뿜한 사람끼리 친구를 구하고<br />함께 할 수 있어요 🔥</StepDetailTxt>
                        <TaskImgWrapper>
                            <img src={`${imgBasePath}matching_tutorial_profile_img_1-650x276.png`}/> 
                        </TaskImgWrapper>
                        <TaskImgWrapper>
                            <img src={`${imgBasePath}matching_tutorial_profile_img_2-650x276.png`}/> 
                        </TaskImgWrapper>
                    </StepDetailWrapper> 
                </StepWrapper>

                <StepWrapper style={{paddingBottom: 'calc(100vw*(58/375))'}}>
                    <StepTitleWrapper>
                        <StepTitleTxt>가장 잘 맞는 메이트를<br />추천해 드려요✨</StepTitleTxt>
                    </StepTitleWrapper>
                    <StepDetailWrapper>
                        <div>
                            <img src={`${imgBasePath}matching_tutorial_recommend_img_1-650x462.png`}/> 
                        </div>
                    </StepDetailWrapper> 
                </StepWrapper>
                <div>
                    <img src={`${imgBasePath}matching_tutorial_sample_img_1-750x1050.png`}/> 
                </div> 
                {
                    (type === 'banner')
                    ?(<StepWrapper>
                        <StepTitleWrapper style={{marginBottom: 'calc(100vw*(9/375))'}}>
                            <StepTitleTxt>매칭기능, 저도 할 수 있나요?</StepTitleTxt>
                        </StepTitleWrapper>
                        <StepDetailWrapper>
                            <StepDetailTxt style={{marginBottom: 'calc(100vw*(30/375))'}}>챌린지 달성률 80% 이상인 분들만<br />참여 가능해요!</StepDetailTxt>
                            <div style={{marginBottom: 'calc(100vw*(67/375))'}}>
                                <img src={`${imgBasePath}matching_tutorial_click_img_1-622x187.png`}/> 
                                <img src={`${imgBasePath}matching_tutorial_click_msg_1-656x92.png`}/> 
                            </div>
                            <LinkButton to={'/'}>홈으로 가기</LinkButton>
                        </StepDetailWrapper> 
                    </StepWrapper>)
                    :(<StepWrapper>
                        <StepTitleWrapper style={{marginBottom: 'calc(100vw*(9/375))'}}>
                            <StepTitleTxt>매칭기능, 저도 할 수 있나요?</StepTitleTxt>
                        </StepTitleWrapper>
                        <StepDetailWrapper>
                            <StepDetailTxt style={{marginBottom: 'calc(100vw*(30/375))'}}>{userInfo['name']}님은 아직 찐 자기계발러가 아니에요. <br />찐 자기계발러가 되려면 챌린지가 <br />하나라도 달성률 80%이상이 되어야 해요!</StepDetailTxt>
                            <div style={{marginBottom: 'calc(100vw*(58/375))'}}>
                                <img src={`${imgBasePath}matching_tutorial_finish_cover_img-607x363.png`}/> 
                            </div>
                            <LinkButton to={'/'}>챌린지 참여하러 가기</LinkButton>
                        </StepDetailWrapper> 
                    </StepWrapper>)
                } 
            </TutorialInfoWrapper>
        </div>
    )
}

const TutorialInfoWrapper = styled.div` 
    word-break: keep-all; 
    font-style: normal;
`; 
const StepWrapper = styled.div`
    margin-bottom : 40px;
    padding : 51px 25px 0 25px;
`;
const StepTitleWrapper = styled.div`
    margin-bottom: 9px;
`;
const StepTitleTxt = styled.span`
    font-weight: bold;
    font-size: calc(100vw*(20/375));
    line-height: calc(100vw*(29/375));
`;
const StepDetailWrapper = styled.div`
    margin-bottom: 15px;
`;
const StepDetailTxt = styled.span`
    display: inline-block;
    font-weight: normal;
    font-size: calc(100vw*(14/375));
    line-height: calc(100vw*(20/375));
`; 
const Emphasize = styled.em`
    font-weight:bold;
`
const TaskImgWrapper = styled.div`
    margin-bottom : calc(100vw*(15/375));
`;
const ProfileImgWrapper = styled.div`
    box-shadow: 0px -4px 30px #ECECEC;
`

const LinkButton = styled(Link)`
    display: inline-block;
    width : 100%;

    background: #FFCF19;
    box-shadow: 0px 0px 20px 7px #FFEEB7;
    border-radius: 91px;

    padding: calc(100vw*(25/375)) 0px;
    
    //Font  
    font-style: normal;
    font-weight: bold;
    font-size: calc(100vw*(18/375));
    line-height: calc(100vw*(26/375));

    text-align: center;
`
